import { DimRelationshipTable } from "./DimRelationshipTable";

export const DimRelationshipSidebar = ({
  relationships,
  config,
  rows,
  lookupFilters,
  onLookupFilterChange,
  onRowClick,
  close
}) => {
  const visibleRelationships =
    relationships.filter(
      (relationship) =>
        relationship.options?.length > 0 &&
        relationship.showInSidebar !== false
    );

  if (!visibleRelationships.length) {
    return null;
  }

  return (
    <aside className="dim-half-screen-column">
      {visibleRelationships.map(
        (relationship) => (
          <DimRelationshipTable
            key={relationship.field}
            relationship={relationship}
            config={config}
            rows={rows}
            searchValue={
              lookupFilters[
                relationship.field
              ] ?? ""
            }
            onSearchChange={(value) =>
              onLookupFilterChange(
                relationship.field,
                value
              )
            }
            onRowClick={onRowClick}
            close={close}
          />
        )
      )}
    </aside>
  );
};